import { EditorContent, useEditor } from "@tiptap/react";
import { StarterKit } from "@tiptap/starter-kit";
import { Placeholder } from "@tiptap/extension-placeholder";
import { Markdown } from "tiptap-markdown";

interface Props {
  initialMarkdown: string;
  onChange: (markdown: string) => void;
  placeholder?: string;
  className?: string;
  readOnly?: boolean;
}

const editorClass =
  "prose prose-sm dark:prose-invert max-w-none focus:outline-none " +
  "prose-headings:font-serif prose-headings:tracking-tight " +
  "prose-code:before:content-none prose-code:after:content-none " +
  "min-h-[18rem] px-2 py-2";

export function MarkdownEditor({
  initialMarkdown,
  onChange,
  placeholder,
  className,
  readOnly = false,
}: Props) {
  const editor = useEditor({
    editable: !readOnly,
    extensions: [
      StarterKit,
      Placeholder.configure({
        placeholder: placeholder ?? "Write your release notes here…",
      }),
      Markdown.configure({
        html: false,
        breaks: true,
        transformPastedText: true,
      }),
    ],
    content: initialMarkdown,
    editorProps: {
      attributes: { class: editorClass },
    },
    onUpdate: ({ editor }) => {
      onChange(editor.storage.markdown.getMarkdown());
    },
  });

  return <EditorContent editor={editor} className={className} />;
}
